<!-- Header -->
<div class="modal-header align-items-center">
  <span class="modal-title-text">Choose a Page Template</span>
  <div class="row g-0 align-items-center sort-by-row">
    <div class="col-sm-4">
      <label class="control-label" for="sortByPageTemplate">Sort By: </label>
    </div>
    <div class="col-sm-8">
      <select class="form-control" name="sortByPageTemplate" id="sortByPageTemplate"
        style="width: 150px;"
        (change)="filterTemplates();"
        [(ngModel)]="templatesSortBy">
        <option value="1">Alphabetical</option>
        <option value="2">Created By</option>
        <option value="3">Updated On</option>
      </select>
    </div>
  </div>
  <i class="material-icons" data-bs-dismiss="modal" (click)='closeModal()'>close</i>
</div>

<div class="fix-height-modal">
  <div class="modal-body playbook-setting">
    <div class="row form-group">
      <!-- Template group list -->
      <div class="col-sm-4">
        <p class="group-menu-text" style="color: gray;">Filter by Group </p>
        <select class="multiSelect form-control" id="templateGrp" multiple (change)="filterTemplates();"
          data-native-menu="false" name="templateGroups" [(ngModel)]="selectedGroups">
          <option value="-1" class="group-option">-- All Groups --</option>
          @for (template of sortAlphabetically(templateGroups); track template) {
            <option [ngValue]="template.id" [value]="template.id"
              [title]="template.name" class="group-option">
              {{template.name}}
            </option>
          }
        </select>
      </div>
      <!-- Template list -->
      <div class="col-sm-8">
        <div class="row">
          <div class="multi-select-preview">
            <ul>
              @for (template of shownTemplates; track template) {
                <li class="page-template">
                  <div class="col-lg-4 col-sm-4 col-xs-12">
                    @if (template.previewImageKey) {
                      <img [src]="setTemplateImgSrc(template) | loadSecureAssets : true | async" class="img-responsive"
                        alt="" (click)="attachViewer(template)" onerror="this.src = 'assets/img/loader.gif'"
                        (load)="imageLoaded = true;" [hidden]="!imageLoaded">
                    }
                    @if (!template.previewImageKey) {
                      <div class="temp-no-image"></div>
                    }
                    <a class="template-title" (click)="selectTemplate(template)">
                      {{template.name}}
                    </a>
                    @if (template.createdByName) {
                      <div class="other-detail">Created By: {{template.createdByName}}</div>
                    }
                    @if (template.lastUpdatedAt) {
                      <div class="other-detail">Updated On: {{template.lastUpdatedAt | date:'MM/dd/yyyy'}}</div>
                    }
                  </div>
                  <div class="col-lg-8 col-sm-8 col-xs-12" style="margin-bottom: 20px;padding-bottom: 20px;">
                    <div style="font-size: 14px;" [innerHtml]="template.description | safeHtml">
                    </div>
                    <button type="button" class="btn btn__btn-default btn__orange apply-button"
                      (click)="selectTemplate(template)">
                      Apply Template
                    </button>
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="modal-footer">
  <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal" (click)='closeModal()'>Cancel</button>
</div>
